<ul class="layout-menu">
    @for (item of store.sidebarOptions(); track $index) {
        @if (!item.separator) {
            <li
                app-menu-item
                [item]="item"
                [index]="$index"
                [root]="true"
                [ngClass]="{'active-menuitem': item|menuPipe:layoutService}"
            ></li>
        } @else {
            <li class="menu-separator"></li>
        }
    }
</ul>
